import { createApp } from 'vue';
import { router } from '@/router';
import Vue from 'vue';
import App from "@/App.vue";
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import FlagIcon from 'vue-flag-icon';
import VueSelect from 'vue3-select2-component'
import DatePicker from 'vue3-datepicker'
import Vue3Autocounter from 'vue3-autocounter';
import Toaster from '@meforma/vue-toaster'
import VueSweetalert2 from 'vue-sweetalert2' 
import 'sweetalert2/dist/sweetalert2.min.css';
import StarRating from 'vue-star-rating'
import VueFeather from 'vue-feather';
import VueApexCharts from "vue3-apexcharts"; 
import VueEasyLightbox from "vue-easy-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import VueFormWizard from "vue3-form-wizard";
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import Themifyicon from "vue-themify-icons";
import SimpleLineIcons from "vue-simple-line";


/*********Header component**********/
import MainHeader from '@/views/layouts/layout-header.vue'
import Invoicefilter from '@/views/layouts/invoice-filter.vue'

/*********Sidebar component**********/
import MainSidebar from '@/views/layouts/layout-sidebar.vue'
import Navbar from '@/views/layouts/navbar-nav.vue'
import SidebarItems from '@/views/layouts/sidebar-items.vue'

/*********Dashboard**********/
import DashboardPage from '@/views/pages/dashboard/index-page.vue' 

//import Taxpurchaseheader from '@/components/breadcrumb/taxpurchase-header.vue'
//import Profitlosslistheader from '@/components/breadcrumb/profitlosslist-header.vue'

/************************ Header   ****************/
//import Quotationreportheader from '@/components/breadcrumb/quotationreport-header.vue'
//import Paymentreportheader from '@/components/breadcrumb/paymentreport-header.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-icons/css/material-icons.min.css';
import 'material-icons/css/material-icons.css';
import 'pe7-icon/dist/dist/pe-icon-7-stroke.css';
import 'typicons.font/src/font/typicons.css';
import 'weathericons/css/weather-icons.css'
import 'ionicons-npm/css/ionicons.css';
import '@/assets/css/vue-form-wizard.css';
import '@/assets/css/feather.css';
import '@/assets/css/style.css'; 
import swal from 'sweetalert2';
window.Swal = swal;
const app = createApp(App)
/*********Header component**********/

//Vue.prototype.$url = process.env.VUE_APP_API_URL;

app.component('layout-header', MainHeader)
app.component('invoicefilter', Invoicefilter);
/*********Sidebar component**********/
app.component('layout-sidebar', MainSidebar)
app.component('navbar', Navbar)
app.component('sidebar-items', SidebarItems)



app.component('vue-select', VueSelect);
app.component('date-picker', DatePicker);
app.component('vue3-autocounter', Vue3Autocounter)
app.component(VueFeather.name, VueFeather);

app.component('star-rating', StarRating)
app.use(Toaster, {
    duration: 3000,
    position: "top-right",
  });
app.use(VueSweetalert2)
app.use(VueEasyLightbox);
app.use(VueApexCharts)
app.use(FlagIcon)
.use(VueFormWizard)
.use(Antd)
.use(VueTelInput)
.use(Themifyicon)
.use(SimpleLineIcons)
.use(BootstrapVue3)
.use(BToastPlugin)
app.use(router).mount('#app');

